'use client';

import { Box, SxProps, Typography } from '@mui/material';
import { Icon, Icons } from '../Icon/Icon';
import {
  clubStatusAnimationWrapperStyles,
  clubStatusCopyStyles,
  clubStatusTextStyles,
  clubStatusWrapperStyles,
} from './ClubStatus.styled';

import Resource from '@/common/components/Resource/Resource';
import { Resource as ResourceType } from '@/generated/contentfulTypes';

interface ClubStatusProps {
  status: ResourceType;
  hideArrow?: boolean;
  wrapperStyles?: SxProps;
  textStyles?: SxProps;
  textLocation?: 'horizontal' | 'vertical';
  fullWidth?: boolean;
}

export default function ClubStatus({
  status,
  hideArrow,
  wrapperStyles,
  textStyles,
  textLocation = 'horizontal',
  fullWidth
}: ClubStatusProps) {
  const copies = Array.from({ length: 20 });

  return (
    <Box sx={clubStatusWrapperStyles(wrapperStyles, textLocation, fullWidth)}>
      <Box sx={clubStatusAnimationWrapperStyles(textLocation)}>
        {copies.map((_, index) => (
          <Box key={index} sx={clubStatusCopyStyles(textStyles, textLocation)}>
            <Typography
              variant="body1"
              component="span"
              sx={clubStatusTextStyles({ index, hideArrow })}
            >
              <Resource {...status} />
            </Typography>
            {!hideArrow && <Icon icon={Icons.Minus} />}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
